<!--
* @Name：供应商营业业绩
* @Author: 王超
* @Date: 2025-09-17 10:39:49
-->
<template>
  <div>
    <hi-card>
      <van-row>
        <span>报价截止时间：</span>
        <span>{{ suppControlInfo.quoteEndDate }}</span>
      </van-row>
      <van-row>
        <span>开标时间：</span>
        <span>{{ suppControlInfo.openBidDate }}</span>
      </van-row>
    </hi-card>
    <hi-card v-for="(item, index) in suppInfoList" :key="item.pcInfoId" :row-index="index + 1">
      <van-row>
        <span>供应商名称：</span>
        <span>{{ item.suppName }}</span>
      </van-row>
      <van-row>
        <span>磋商次数：</span>
        <span>{{ item.consultCount }}</span>
      </van-row>
    </hi-card>
  </div>
</template>

<script>
export default {
  name: 'suppInfoList',
  data() {
    return {}
  },
  props: {
    suppControlInfo: {
      type: Object,
      required: true
    },
    suppInfoList: {
      type: Array,
      required: true
    }
  },
  computed: {
    enterpriseTypeDictOptions() {
      return this.$store.getters.dicts.enterprise_character
    },
    quoteStatusDictOptions() {
      return this.$store.getters.dicts.quote_status
    }
  }
}
</script>
